package com.eladfinish.bible.contest.di.shake

import org.koin.dsl.module

val shakeModule = module {
    includes(shakePlatformModule)
}
